import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const TitleFlex = styled.div`
    display: flex;
`;

export const Title = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
`;

export const MandatorySign = styled.div`
    color: #d83d37;
`;

export const FileUploadInput = styled.div`
    margin-top: 8px;
    cursor: pointer;
`;

export const FileUploadWrapper = styled.div<{ isUploaded: boolean }>`
    display: flex;
    padding: 10px;
    border: 1px dashed #0fa457;
    border-radius: 8px;
    ${(props) =>
        props.isUploaded &&
        `background: #F8F7FC;
        border: none;
`}
`;

export const PlusIconFlex = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`;

export const UploadLabel = styled.div`
    display: flex;
    flex: 8;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-left: 5px;
`;

export const DeleteIconFlex = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`;
